import React, { Component } from 'react'
import Table from '@common/Table'
import store from '../store'
import columns from './column'
import mainStore from '@components/Main/store'
import { observer } from 'mobx-react'

@observer
export default class extends Component {
  render() {
    const { merchantInfo } = mainStore

    return (
      <Table
        store={store}
        columns={
          merchantInfo.property_id == 6
            ? columns
            : columns.filter(item => item.key != 'second_category')
        }
      />
    )
  }
}
